export default "__VITE_ASSET__c9a845b3__"